module.exports = "/_next/static/images/FrameMobile-484225fb210a2ab0ceb3022a5c432867.webp";